<template>
  <div>
    <div :style="{height:imgWidth*0.262 + 'px',width:imgWidth}">
      <div class="imgTitle">电测 计量 检定 校验</div>
      <img style="width:100%;height:100%;" v-for="item in img" :key="item.id" :src="item.image" alt />
    </div>
    <div id="main">
      <div class="main_title">
        <div class="line"></div>
        <div>
          联系我们
          <span style="margin-left:40px;">CONTACT US</span>

          <router-link to="/">
            <img class="back_to_index" src="../../assets/images/back_to_index.png" alt />
          </router-link>
        </div>
      </div>

      <div class="message_title">联系我们</div>
      <div class="contact_away">
        <span v-for="item in contactUs.list" :key="item">{{item}}</span>
      </div>

      <div class="message_title">客户留言</div>
      <div class="userName">
        <span>姓名：</span>
        <input type="text" v-model="userName" placeholder="请输入您的姓名" />
      </div>
      <div class="userPhoneNum">
        <span>联系方式：</span>
        <input type="text" v-model="userPhoneNum" placeholder="请输入您的联系方式" />
      </div>
      <div class="message_textarea">
        <el-input :rows="7" type="textarea" v-model="message" placeholder="输入你想说的留言"></el-input>
      </div>

      <button @click="submit">发送</button>
      <!-- <div class="kehu_msg">
        <p class="message_title" style="margin-bottom:20px;">
          最新留言：
        </p>
        <br>
        {{this.contactUs.msg.name}}在{{this.contactUs.msg.createtime}}时留言：{{this.contactUs.msg.message}} </div> -->
      
      <div class="message_title">{{contactUs.name}}</div>

      <div class="message_title">地图位置</div>

      <img style="width:100%;height:320px;margin-bottom:40px;" :src="contactUs.map" alt />
    </div>
  </div>
</template>
<script>
export default {
  data:function() {
    return {
      contactUs: "", // 联系我们信息
      message: "",
      userName: "",
      userPhoneNum: "",
      img: [],
      imgWidth: "",
    };
  },
  methods: {
    submit: function () {
      if (this.userName == "" || this.userName == " ") {
        alert("请输入您的姓名");
      } else if (this.userPhoneNum == "" || this.userPhoneNum == " ") {
        alert("请输入您的联系方式");
      } else if (this.message == "" || this.message == " ") {
        alert("请输入您的意见");
      } else {
        this.$fetch("aboutus/sendMessage", {
          message: this.message,
          tel: this.userPhoneNum,
          name: this.userName,
        }).then((res) => {
          if (res.code == 1) {
            // console.log(res);
            alert("提交成功");
            this.userName = "";
            this.userPhoneNum = "";
            this.message = "";
          } else {
            alert("请求出错，请稍后再试");
          }
        });
      }
    }
  },
  created: function () {
    // 获取头图数据
    this.$fetch("index/getAdList", { slot_id: 2 }).then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.img = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
    this.imgWidth = document.body.clientWidth;
    setTimeout(function () {
      $(".imgTitle").css({ transform: "scale(1)", transition: "2s" });
    }, 1000);
    setTimeout(function () {
      $(".imgTitle").css({ transform: "scale(0)", transition: "2s" });
    }, 3000);
    setInterval(() => {
      setTimeout(function () {
        $(".imgTitle").css({ transform: "scale(1)", transition: "2s" });
      }, 1000);
      setTimeout(function () {
        $(".imgTitle").css({ transform: "scale(0)", transition: "2s" });
      }, 3000);
    }, 5000);
  },
  mounted: function () {
    this.$fetch("Aboutus/contact").then((res) => {
      if (res.code == 1) {
        console.log(res);
        this.contactUs = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
  }
};
</script>
<style scoped>
.heiti {
  font-family: SimHei;
}
.imgTitle {
  position: absolute;
  color: #0ca00f;
  font-size: 54px;
  font-family: SimHei;
  font-weight: bold;
  top: 250px;
  left: 34%;
  z-index: 10;
  transform: scale(0);
}
.main_title {
  width: 100%;
  height: 24px;
  margin: 40px 0;
  font-size: 20px;
}
.line {
  background-color: #2569e6;
  width: 3px;
  height: 100%;
  float: left;
  margin-right: 20px;
}
.message_title {
  font-size: 20px;
  margin-bottom: 30px;
  font-family: Helvetica;
  font-weight: bold;
}
.message_textarea {
  width: 100%;
  height: 150px;
  margin: 20px 0 30px 0;
}
button {
  width: 100px;
  height: 50px;
  background-color: #2569e6;
  color: #fff;
  outline: none;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  margin-bottom: 40px;
}
.contact_away {
  margin: 20px 0;
}
.contact_away span {
  display: inline-block;
  padding-left: 5%;
  width: 28%;
  color: #838383;
  text-align: left;
  margin: 25px 0;
}
.contact_away span:nth-child(5) {
  margin-right: 0;
}
.contact_away span:nth-child(11) {
  margin-right: 0;
}
.userName,
.userPhoneNum {
  line-height: 100px;
}
.userName span,
.userPhoneNum span {
  display: inline-block;
  width: 100px;
  text-align: right;
}
.userName input,
.userPhoneNum input {
  height: 60px;
  width: 460px;
  background-color: #f8f8fa;
  border-radius: 10px;
  outline: none;
  border: none;
  padding-left: 20px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/contactUs/contactUs.vue